var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import styled, { css } from 'styled-components';
import { classNames, cn, entityLabel, entityTypeNameFor } from '@shapeable/utils';
import { breakpoints, theme } from '@shapeable/theme';
import { EntityBubbleImage } from './entity-bubble-image';
import { CellHeader } from '../elements/cell-header';
import { Highlighter } from '../elements/highlighter';
import { EntityImagePathsDefault } from './entity-image';
import { includes } from 'lodash';
import { useLang } from '../hooks/use-lang';
import { ContentNode } from './content-node';
import { OutlineEntityBubble } from './outline-entity-bubble';
import { useEntityTypeLabel } from '../context/entity-type-labels-context';
import { useComponentPropsFor } from '../context/component-props-context';
var cls = classNames('entity-value');
export var EntityValueImagePathsDefault = ['banner.thumbnail', 'openGraph.image', 'image'];
export var EntityValueImageSizes = {
  tiny: 16,
  small: 36,
  default: 48,
  smallName: 24,
  content: 36,
  summary: 48,
  card: 36,
  name: 32,
  person: 57,
  title: 24,
  bannerLarge: 60,
  large: 80,
  banner: 80,
  embed: 48
};
export var EntityValueFontSizes = {
  tiny: 12,
  small: 13,
  card: 14,
  default: 15,
  name: 15,
  person: 15,
  content: 0,
  smallName: 13,
  summary: 17,
  title: 15,
  bannerLarge: 30,
  large: 15,
  banner: 20,
  embed: 16
};
export var EntityValueSpacing = {
  tiny: 2,
  small: 1,
  card: 1,
  default: 1.5,
  name: 0,
  person: 1,
  content: 1,
  smallName: 0,
  summary: 1.5,
  title: 0,
  bannerLarge: 1.5,
  large: 1.5,
  banner: 2,
  embed: 2
};
export var EntityValueImageSpacing = {
  tiny: 2,
  small: 2.5,
  card: 2.5,
  content: 2.5,
  default: 3,
  name: 2,
  person: 2.5,
  smallName: 2,
  summary: 3,
  title: 2,
  bannerLarge: 4,
  large: 3,
  banner: 3,
  embed: 2
};
export var EntityValueLabelFontSizes = {
  tiny: 11,
  small: 11,
  card: 12,
  content: 0,
  default: 13,
  name: 15,
  person: 15,
  smallName: 13,
  summary: 14,
  title: 15,
  bannerLarge: 13,
  large: 15,
  banner: 15,
  embed: 15
};
export var EntityValueDefaultProps = {
  imagePaths: EntityImagePathsDefault,
  variant: 'default',
  imageStyle: 'default',
  wrap: true,
  showMenu: false,
  showImage: true,
  showOutlineNumber: false
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    color: ", ";\n  "], ["\n    color: ", ";\n  "])), theme.COLOR('strong'))
});
var BodyStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    ", "\n\n    ", "\n    \n    .", " {\n      line-height: 1.05em;\n    }\n\n    button.ellipsis-button {\n      visibility: hidden;\n    }\n\n    &:hover button.ellipsis-button {\n      visibility: visible;\n    }\n    \n  "], ["\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    ", "\n\n    ", "\n    \n    .", " {\n      line-height: 1.05em;\n    }\n\n    button.ellipsis-button {\n      visibility: hidden;\n    }\n\n    &:hover button.ellipsis-button {\n      visibility: visible;\n    }\n    \n  "])), function (_a) {
    var variant = _a.variant;
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      font-size: ", ";\n    "], ["\n      font-size: ", ";\n    "])), EntityValueFontSizes[variant] ? theme.FONT_SIZE(EntityValueFontSizes[variant]) : '1em');
  }, function (_a) {
    var variant = _a.variant;
    return variant === 'summary' && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      padding-bottom: ", ";\n    "], ["\n      padding-bottom: ", ";\n    "])), theme.UNIT(4));
  }, cn('cell-label'))
});
var LabelStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (_a) {
    var variant = _a.variant;
    return css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      font-size: ", "em;\n      color: ", "; \n\n      ", "\n\n      .", " {\n        font-size: 1em;\n      }\n\n      .", " {\n        margin-top: -2px;\n      }\n    "], ["\n      font-size: ", "em;\n      color: ", "; \n\n      ", "\n\n      .", " {\n        font-size: 1em;\n      }\n\n      .", " {\n        margin-top: -2px;\n      }\n    "])), EntityValueFontSizes[variant] ? EntityValueLabelFontSizes[variant] / EntityValueFontSizes[variant] : 1, theme.COLOR('sub'), function (props) {
      return props.hasName && css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n        margin-bottom: ", ";\n      "], ["\n        margin-bottom: ", ";\n      "])), theme.UNIT(EntityValueSpacing[variant]));
    }, cn('cell-label'), cn('badge'));
  })
});
var NameStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    margin: 0;\n    font-size: 1em;\n    font-weight: 500;\n    padding: 0;\n    color: inherit;\n    display: flex;\n    align-items: center;\n    line-height: 1.05em;\n    text-align: left;\n  \n\n    ", "\n  "], ["\n    margin: 0;\n    font-size: 1em;\n    font-weight: 500;\n    padding: 0;\n    color: inherit;\n    display: flex;\n    align-items: center;\n    line-height: 1.05em;\n    text-align: left;\n  \n\n    ", "\n  "])), function (props) {
    return !props._wrap && css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n      flex-wrap: nowrap;\n    "], ["\n      flex-wrap: nowrap;\n    "])));
  })
});
var LabelAndNameStyles = breakpoints({
  base: css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n\n    ", "\n  "], ["\n\n    ", "\n  "])), function (props) {
    return props.hasImage && css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n      margin-left: ", ";\n    "], ["\n      margin-left: ", ";\n    "])), theme.UNIT(props.imageSpacing));
  })
});
var ImageStyles = breakpoints({
  base: css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    flex-shrink: 0;\n  "], ["\n    flex-shrink: 0;\n  "])))
});
var OutlineBubbleStyles = breakpoints({
  base: css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    flex-shrink: 0;\n    \n  "], ["\n    flex-shrink: 0;\n    \n  "])))
});
var SubtitleStyles = breakpoints({
  base: css(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    ", ";\n    font-weight: 300;\n\n    ", "\n  "], ["\n    ", ";\n    font-weight: 300;\n\n    ", "\n  "])), NameStyles, function (_a) {
    var variant = _a.variant;
    return css(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n      margin-top: ", ";\n    "], ["\n      margin-top: ", ";\n    "])), theme.UNIT(EntityValueSpacing[variant]));
  })
});
var subHeadingStyles = breakpoints({
  base: css(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), SubtitleStyles)
});
var MetaStyles = breakpoints({
  base: css(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var DescriptionStyles = breakpoints({
  base: css(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n    font-weight: 300;\n  "], ["\n    font-weight: 300;\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Body: styled.div.attrs(cls.attr('body'))(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Image: styled(EntityBubbleImage)(templateObject_21 || (templateObject_21 = __makeTemplateObject(["", ""], ["", ""])), ImageStyles),
  OutlineBubble: styled(OutlineEntityBubble)(templateObject_22 || (templateObject_22 = __makeTemplateObject(["", ""], ["", ""])), OutlineBubbleStyles),
  LabelAndName: styled.div.attrs(cls.attr('label-and-name'))(templateObject_23 || (templateObject_23 = __makeTemplateObject(["", ""], ["", ""])), LabelAndNameStyles),
  Label: styled(CellHeader)(templateObject_24 || (templateObject_24 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles),
  Name: styled.h2.attrs(cls.attr('name'))(templateObject_25 || (templateObject_25 = __makeTemplateObject(["", ""], ["", ""])), NameStyles),
  subHeading: styled.h4.attrs(cls.attr('pre-subtitle'))(templateObject_26 || (templateObject_26 = __makeTemplateObject(["", ""], ["", ""])), subHeadingStyles),
  Subtitle: styled.h4.attrs(cls.attr('subtitle'))(templateObject_27 || (templateObject_27 = __makeTemplateObject(["", ""], ["", ""])), SubtitleStyles),
  Meta: styled.div(templateObject_28 || (templateObject_28 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles),
  Description: styled(ContentNode)(templateObject_29 || (templateObject_29 = __makeTemplateObject(["", ""], ["", ""])), DescriptionStyles)
};
export var EntityValue = function (props) {
  var _a;
  var componentProps = useComponentPropsFor('EntityValue', EntityValueDefaultProps, props);
  var className = componentProps.className,
    entity = componentProps.entity,
    variant = componentProps.variant,
    badge = componentProps.badge,
    highlight = componentProps.highlight,
    imageStyle = componentProps.imageStyle,
    imagePaths = componentProps.imagePaths,
    alwaysShowIcon = componentProps.alwaysShowIcon,
    showImage = componentProps.showImage,
    subtitle = componentProps.subtitle,
    wrap = componentProps.wrap,
    onClick = componentProps.onClick,
    showOutlineNumber = componentProps.showOutlineNumber,
    subHeading = componentProps.subHeading,
    outlineBubble = componentProps.outlineBubble,
    showImageBorder = componentProps.showImageBorder,
    meta = componentProps.meta;
  var imageSize = props.imageSize || EntityValueImageSizes[variant];
  var imageSpacing = props.imageSpacing || EntityValueImageSpacing[variant];
  var showLabel = props.showLabel === undefined ? !includes(["name", "smallName", "title", "tiny"], variant) : props.showLabel;
  var hasSubtitle = !!props.subtitle;
  var hasSubHeading = !!props.subHeading;
  var hasMeta = props.meta !== undefined;
  var t = useLang();
  var name = props.name === '' ? '' : props.name || entity && entity.name;
  var hasDescription = variant === 'summary';
  var contextLabel = useEntityTypeLabel(entityTypeNameFor(entity));
  var label = props.label || (entity === null || entity === void 0 ? void 0 : entity.typeLabel) || ((_a = entity._schema) === null || _a === void 0 ? void 0 : _a.label) || contextLabel || entityLabel(entity);
  var showOutline = showOutlineNumber && !showImage;
  return React.createElement(My.Container, {
    onClick: onClick,
    className: cls.name(className)
  }, React.createElement(My.Body, {
    variant: variant
  }, showImage && React.createElement(My.Image, {
    alwaysShowIcon: alwaysShowIcon,
    size: imageSize,
    showBorder: showImageBorder,
    imageStyle: imageStyle,
    entity: entity
  }), showOutline && React.createElement(My.OutlineBubble, __assign({
    entity: entity
  }, outlineBubble)), React.createElement(My.LabelAndName, {
    hasImage: showImage || showOutline,
    imageSpacing: imageSpacing,
    variant: variant
  }, showLabel && React.createElement(My.Label, {
    hasName: !!name,
    variant: variant,
    badge: badge
  }, t(label)), React.createElement(My.Name, {
    _wrap: wrap,
    variant: variant
  }, highlight ? React.createElement(Highlighter, {
    searchWords: [highlight],
    textToHighlight: name
  }) : name), hasSubtitle && React.createElement(My.Subtitle, {
    variant: variant
  }, subtitle), hasMeta && React.createElement(My.Meta, null, meta))), hasDescription && React.createElement(My.Description, {
    variant: variant,
    entity: entity.description
  }));
};
EntityValue.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29;
// EntityValue.defaultProps = EntityValueDefaultProps;